import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Typography from "@/components/ui/typography";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname,
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center space-y-4">
        <Typography size="h1">404</Typography>
        <Typography size="sh2" className="text-gray-600">
          Oops! Page not found
        </Typography>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
